import { render } from "./DataCollection.vue?vue&type=template&id=b3d50e9c&scoped=true"
import script from "./DataCollection.vue?vue&type=script&lang=js"
export * from "./DataCollection.vue?vue&type=script&lang=js"

import "./DataCollection.vue?vue&type=style&index=0&id=b3d50e9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3d50e9c"]])

export default __exports__